module.exports = __webpack_public_path__ + "img/imageSimilar.47146967.png";